import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { Store } from 'src/app/core/store/store';
import { User } from 'src/app/shared/models/user.model';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { LoadingComponent } from '../../../partner-dashboard/common/loader/loading'


declare function closeNavMobile(): any;
@Component({
  selector: 'app-partner-dashboard-layout',
  templateUrl: './partner-dashboard-layout.component.html',
  styleUrls: ['./partner-dashboard-layout.component.css']
})
export class PartnerDashboardLayoutComponent implements OnInit {

  showSidebar = true;
  user: User;

  constructor(private router: Router, private store: Store, private partnerService: PartnerService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // closeNavMobile();
      }
      if (event instanceof NavigationEnd) {
        if (event.url.includes('dashboard/hiration')) {
          this.showSidebar = false;
        } else {
          this.showSidebar = true;
        }
      }
    });
  }

  ngOnInit(): void {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('dashboard/hiration')) {
          this.showSidebar = false;
        } else {
          this.showSidebar = true;
        }
      }
    });

    this.store.select('user').pipe(distinctUntilChanged()).subscribe((user: User) => {
      this.user = user;

      if (user?.role === 'ADMIN') {
        this.partnerService.getOrganizations().subscribe(res => {
          if (res) {
            this.store.set('organizations', res);
            if (res.length > 0) {
              const sessionOrganization = sessionStorage.getItem('currentOrganization');
              let org = res[0];

              if(sessionOrganization){
                org = sessionOrganization;
              }

              sessionStorage.setItem('currentOrganization', org);
              this.store.set('currentOrganization', org);
            }
          }
        });
      }

      if (user?.role === 'PARTNER_ADMIN') {
         sessionStorage.setItem('currentOrganization', user.organization);

         this.store.set('currentOrganization', user.organization);
      }
    });

  }

}
